<template>
  <div>
    <div class="search-ipt">
      <Input v-model="search_keyword" @on-enter="haddleSearch">
      <Select v-model="search_type" slot="prepend">
        <Option value="all">全部</Option>
        <Option v-for="item in list_type" :value="item.id" :key="item.id">{{item.name}}</Option>
      </Select>
      <Button slot="append" @click="haddleSearch">搜索</Button>
      </Input>
    </div>
    <div class="search-cnt" v-if="show_keyword != ''" v-show="!all_loading && !loading">
      <div v-if="select_type === 'all'">
        <p class="search-tip">当前含“<span>{{show_keyword}}</span>”的{{active_type | dealName(this.list_type)}}搜索结果约{{list_count[active_type]}}条</p>
        <ul class="search-nav">
          <li v-for="item in list_type" :key="item.id" :class="{active: active_type == item.id}">
            <a @click="haddleChangeShowType(item.id)">{{item.name}}
              <!-- <span v-if="list_count[item.id] || list_count[item.id] === 0">({{list_count[item.id]}})</span> -->
            </a>
          </li>
        </ul>
      </div>
      <div :class="'search-type-tip search-type-tip-' + select_type" v-else>
        <p class="tip-l"><span>{{list_name(select_type)}}</span></p>
        <p class="tip-r">含“<span>{{show_keyword}}</span>”{{select_type | dealName(this.list_type)}}的搜索结果约{{list_count[select_type] | empty('0')}}条</p>
      </div>
      <div class="change-full" v-if="(select_type === 'all' && active_type=='7') || select_type=='7'">
        <span :class="{on: is_fulltext == 0}" @click="handleChangeFull(0)">搜索标题</span>
        <span :class="{on: is_fulltext == 1}" @click="handleChangeFull(1)">全文检索</span>
      </div>
      <div :class="{'search-bottom': active_type!='1' && select_type!='1'}">
        <div class="search-list" v-if="!isNothing">
          <ul class="article" v-if="(select_type === 'all' && active_type=='7') || select_type=='7'">
            <SearchArticle v-for="item,index in list_data['7']" :dataLi="item" :keyword="show_keyword" :meta="meta" :key="index"></SearchArticle>
          </ul>
          <ul class="topic" v-if="(select_type === 'all' && active_type=='0') || select_type=='0'">
            <SearchTopicList v-for="item,index in list_data['0']" :dataLi="item" :keyword="show_keyword" :key="index"></SearchTopicList>
          </ul>
          <ul class="theme clear" v-if="(select_type === 'all' && active_type=='1') || select_type=='1'">
            <SearchThemeList v-for="item,index in list_data['1']" :dataLi="item" :keyword="show_keyword" :payThemeType="pay_theme_type" :key="index"></SearchThemeList>
          </ul>
          <ul class="report clear" v-if="(select_type === 'all' && active_type=='6') || select_type=='6'">
            <SearchReport v-for="item,index in list_data['6']" :dataLi="item" :keyword="show_keyword" :key="index"></SearchReport>
          </ul>
          <ul class="entity clear" v-if="(select_type === 'all' && active_type=='2') || select_type=='2'">
            <SearchCompList v-for="item,index in list_data['2']" :dataLi="item" :keyword="show_keyword" :key="index"></SearchCompList>
          </ul>
          <ul class="entity clear" v-if="(select_type === 'all' && active_type=='3') || select_type=='3'">
            <SearchOrgList v-for="item,index in list_data['3']" :dataLi="item" :keyword="show_keyword" :key="index"></SearchOrgList>
          </ul>
          <ul class="entity clear" v-if="(select_type === 'all' && active_type=='4') || select_type=='4'">
            <SearchHospitalList v-for="item,index in list_data['4']" :dataLi="item" :keyword="show_keyword" :key="index"></SearchHospitalList>
          </ul>
          <ul class="policy" v-if="(select_type === 'all' && active_type=='5') || select_type=='5'">
            <SearchPolicyList v-for="item,index in list_data['5']" :dataLi="item" :keyword="show_keyword" :index="index" :key="index"></SearchPolicyList>
          </ul>
          <ul class="author entity clear" v-if="(select_type === 'all' && active_type=='8') || select_type=='8'">
            <SearchAuthorList v-for="item,index in list_data['8']" :dataLi="item" :keyword="show_keyword" :index="index" :key="index"></SearchAuthorList>
          </ul>
        </div>
        <Nothing v-if="isNothing">
          <p>没有找到相关的内容<br><a @click="haddleBackModel">我要反馈</a></p>
        </Nothing>
        <div class="more" v-if="isMore">
          <button @click="haddleClickMore" v-if="search_code != 400 && !more_loading">加载更多</button>
          <div class="more-loading" v-if="more_loading">
            <Spin fix>
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          </div>
          <div class="nc-cnt" v-if="search_code == 400 && !more_loading && clk_dom == 2">
            <div id="nc1"></div>
          </div>
        </div>
        <div v-if="!isMore && page[active_type] > 1" class="over">已加载完</div>
      </div>
    </div>
    <Nothing v-if="show_keyword == '' && !(all_loading || loading)">
      <p>请输入关键字查询</p>
    </Nothing>
    <div class="loading-spin" v-if="all_loading || loading">
      <Spin fix>
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </div>
  </div>
</template>
<script>
import { search, getUserPayThemeType } from '../../service'
import SearchHospitalList from './components/SearchHospitalList.vue'
import SearchCompList from './components/SearchCompList.vue'
import SearchOrgList from './components/SearchOrgList.vue'
import SearchPolicyList from './components/SearchPolicyList.vue'
import SearchThemeList from './components/SearchThemeList.vue'
import SearchTopicList from './components/SearchTopicList.vue'
import SearchReport from './components/SearchReport.vue'
import SearchArticle from './components/SearchArticle.vue'
import SearchAuthorList from './components/SearchAuthorList.vue'
import Nothing from './components/Nothing.vue'
import { get_meta } from 'js/get_meta'
import { userInfo } from 'js/userInfo'
import { uuid } from 'js/uuid'
import Cookies from 'js-cookie'
function check() {
    function doCheck(a) {
        (function() {}["constructor"]("debugger")()); 
        doCheck(++a);
    }
    try {
        doCheck(0)
    } catch(err) {}
}
export default {
  mixins: [get_meta, userInfo, uuid],
  inject: ['login', 'haddleBackModel'],
  data() {
    return {
      list_type: [
        { name: '文章', id: 7 },
        { name: '快讯', id: 0 },
        { name: '专题', id: 1 },
        { name: '报告', id: 6 },
        { name: '公司', id: 2 },
        { name: '金融机构', id: 3 },
        { name: '医院', id: 4 },
        { name: '政策', id: 5 },
        { name: '作者', id: 8 },
      ],
      search_type: 'all',
      select_type: 'all',
      active_type: 7,
      search_keyword: '',
      show_keyword: '',
      page: {},
      list_count: {},
      list_loading: {},
      loading: false,
      list_data: {},
      list_length: {},
      more_loading: false,
      is_fulltext: 0,
      pay_theme_type: [],
      now_page: 1,
      is_sear_btn: false,
      search_params: {
        type: '',
        keyword: '',
        is_all: '',
      },
      search_code: 0,
      page_status: 0, //0点击加载更多，页码不变，1页码+1
      debugger_interval: ''
    }
  },
  components: {
    SearchTopicList,
    SearchThemeList,
    SearchPolicyList,
    SearchOrgList,
    SearchCompList,
    SearchHospitalList,
    SearchReport,
    SearchArticle,
    SearchAuthorList,
    Nothing,
  },
  computed: {
    query_keyword() {
      return this.$route.query.keyword
    },
    all_loading() {
      let arr = []
      for (let prop in this.list_loading) {
        arr.push(this.list_loading[prop])
      }
      return arr.findIndex((a) => a === true) > -1
    },
    all_count() {
      let total = 0
      for (let prop in this.list_count) {
        total = total + this.list_count[prop]
      }
      return total
    },
    list_name() {
      return function (item_id) {
        let index = this.list_type.findIndex((a) => a.id == item_id)
        return this.list_type[index].name
      }
    },
    isNothing() {
      if (this.select_type == 'all') {
        return this.list_count[this.active_type] == 0
      } else {
        return this.list_count[this.select_type] == 0
      }
    },
    isMore() {
      let type = this.select_type == 'all' ? this.active_type : this.select_type
      return type == '1'
        ? this.now_page < Math.ceil(this.list_count[type] / 12)
        : this.now_page < Math.ceil(this.list_count[type] / 10)
    },
  },
  methods: {
    /**
     * 关键字查询列表
     * type: 类型
     * keyword: 关键字
     * is_all: 是否查询全部类型，1=是，0=否
     */
    async getSearch(type, keyword, is_all) {
      this.clk_dom = 1
      this.loading = true

      if (is_all) this.list_loading[type] = true

      let params = {
        // data: nvcVal,
        type: type,
        keyword: keyword,
        page: this.page[type],
        user_key: this.$store.state.user_key,
      }
      if (type == 7) params.is_fulltext = this.is_fulltext
      let res = await search(params, (error) => {
        this.$Message.error('请求错误！')
      })
      this.loading = false
      this.select_type = this.search_type
      this.show_keyword = keyword
      this.is_sear_btn = false
      if (res.status == 'success') {
        if (res.res == null) {
          this.$Message.warning('请求失败，请重试')
        } else {
          if (is_all) {
            this.list_loading[type] = false
            this.list_loading = { ...this.list_loading }
          }
          this.list_count[type] = res.res.count
          this.list_count = { ...this.list_count }
          this.list_data[type] = res.res.list
          this.list_data = { ...this.list_data }
          this.list_length[type] = res.res.list.length
          this.list_length = { ...this.list_length }
          this.$forceUpdate()
          this.$previewRefresh()
        }
      } else {
        this.$Message.error(res.message)
      }

      // this.loading = true
      // this.search_params = {
      //   type: type,
      //   keyword: keyword,
      //   is_all: is_all,
      // }
      // this.checkUserBehavior()
    },
    haddleSearch() {
      this.now_page = 1
      for (let prop in this.page) {
        this.page[prop] = 1
      }
      if (this.search_keyword != '') {
        if (this.search_type === 'all') {
          _czc.push(['_trackEvent', '搜索', '搜索范围点击（全部）'])
          this.getSearch(this.active_type, this.search_keyword, 1)
        } else {
          let index = this.list_type.findIndex((a) => a.id == this.search_type)
          _czc.push(['_trackEvent', '搜索', '搜索范围点击（' + this.list_type[index].name + '）'])
          this.getSearch(this.search_type, this.search_keyword, 0)
        }
        this.is_sear_btn = true
        this.$router.replace({ name: 'SearchList', query: { keyword: this.search_keyword } })
      } else {
        this.$Message.warning('请输入关键字，关键字不能为空')
        this.show_keyword = this.search_keyword
      }
    },
    haddleChangeShowType(item_id) {
      this.active_type = item_id
      for (let prop in this.page) {
        this.page[prop] = 1
      }
      this.now_page = 1
      this.getSearch(item_id, this.show_keyword, 1)
    },
    async haddleClickMore() {
      this.more_loading = true
      let type = this.select_type == 'all' ? this.active_type : this.select_type
      this.page[type]++
      this.now_page = this.page[type]
      let params = {
        // data: nvcVal,
        type: type,
        keyword: this.show_keyword,
        page: this.page[type],
        user_key: this.$store.state.user_key,
      }
      if (type == 7) params.is_fulltext = this.is_fulltext
      let res = await search(params, (error) => {
        this.$Message.error('请求错误！')
      })
      this.more_loading = false
      if (res.status == 'success') {
        res.res.list.map((a) => {
          this.list_data[params.type].push(a)
        })
        this.list_data = { ...this.list_data }
        this.list_length[params.type] = res.res.list.length
        this.list_length = { ...this.list_length }
        if (res.res.list.length == 0) {
          this.$Message.warning('没有更多了')
        }
        this.$forceUpdate()
        this.$previewRefresh()
      } else {
        this.$Message.error(res.message)
      }
    },
    handleChangeFull(val) {
      this.is_fulltext = val
      this.haddleSearch()
    },
    async getUserPayThemeType() {
      let res = await getUserPayThemeType(
        {
          user_key: this.$store.state.user_key,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'pay_theme_type', res.res)
      } else {
        this.$Message.error(res.message)
      }
    },
    pageInit() {
      this.$nextTick(() => {
        if (this.query_keyword) {
          this.getSearch(this.active_type, this.query_keyword, 1)
        }
      })
    },
  },
  created() {
    this.getMeta(['media_tag'])

    let local_uuid = Cookies.get('uuid')
    if (!this.$store.state.uUid || this.$store.state.uUid == null) {
      if (local_uuid && local_uuid != null) {
        this.$store.commit('setUUid', local_uuid)
      } else {
        let u = this.uuid()
        Cookies.set('uuid', u, { domain: this.$store.state.domain_path, path: '/'})
        this.$store.commit('setUUid', u)
      }
    }

    if (this.query_keyword) {
      this.loading = true
      this.search_keyword = this.query_keyword
      this.getSearch(this.active_type, this.search_keyword, 1)
    } else {
      this.show_keyword = ''
    }
    if (this.$store.state.user_key) {
      this.getUserPayThemeType()
    }
    this.list_type.map((a) => {
      this.list_count[a.id] = ''
      this.list_data[a.id] = []
      this.list_length[a.id] = 0
      this.page[a.id] = 1
    })
  },
  mounted() {
    if (process.env.NODE_ENV != 'development') {
      check()
      this.debugger_interval = setInterval(() => {
        check()
      }, 2000)
    }
  },
  beforeDestroy() {
    clearInterval(this.debugger_interval)
    this.debugger_interval = ''
  },
  watch: {
    query_keyword(value) {
      if (!this.is_sear_btn) {
        this.search_keyword = value
        this.show_keyword = value
        if (value != '') {
          this.getSearch(this.active_type, value, 1)
        }
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.search-ipt
  width 700px
  margin 30px auto 0
  >>> .ivu-input
    height 48px
    commonBgColor(#2A2F42, #FFFFFF)
    border 0
    border-left 1px solid
    commonBorderColor(#40444F, #F4F6F8)
    padding 6px 20px
    font-size 16px
    commonColor(#FFFFFF, #333333)
    &:focus
      box-shadow none
  >>> .ivu-input-group-append, >>> .ivu-input-group-prepend
    font-size inherit
    font-weight normal
    line-height 1
    commonColor(#515a6e, #666666)
    text-align center
    commonBgColor(#2A2F42, #FFFFFF)
    border-radius 0
    border 0
    padding 0
  >>> .ivu-input-group-prepend
    width 90px
    .ivu-select
      width 90px
      height 48px
      commonColor(#BCBDC1, #666666)
      .ivu-select-selection
        height 48px
        border-radius 0
        border 0
        margin 0
        .ivu-select-selected-value
          height 48px
          line-height 48px
          font-size 16px
        .ivu-select-arrow
          font-size 16px
          color #8F9198
          right 15px
      .ivu-select-dropdown
        commonBgColor(#2A2F42, #FFFFFF)
        border-radius 0
        max-height none
        overflow initial
        commonShadow(0 1px 6px rgba(0, 0, 0, 0.2), 2px 4px 20px 0px rgba(121, 133, 143, 0.1))
      .ivu-select-item
        commonColor(rgba(255, 255, 255, 0.6), #666666)
        font-size 14px !important
        &:hover
          commonBgColor(#35383f, #FFFFFF)
        &-focus
          background transparent
      .ivu-select-item-selected
        color rgba(250, 122, 80, 1) !important
        &:hover
          color rgba(250, 122, 80, 1)
  >>> .ivu-input-group-append
    width 100px
    .ivu-btn
      margin 0
      width 100%
      height 48px
      border 0
      font-size 16px
      color #FFFFFF
      background-color rgba(250, 122, 80, 1)
      border-radius 0
      box-shadow none
      &:hover
        background-color #FC9C7C
.nc-cnt
  width 700px
  margin 10px auto 0
  height 34px
  display flex
  justify-content center
  >>> .nc-container
    width 300px
    .nc_scale
      span
        box-sizing content-box
.search-cnt
  width 1200px
  margin 30px auto 0
  padding-bottom 20px
  position relative
  .search-tip
    font-size 12px
    commonColor(#BCBDC1, #666666)
    text-align center
    span
      color rgba(250, 122, 80, 1)
  .search-nav
    commonBgColor(#1f2330, #FFFAF5)
    text-align center
    margin-top 20px
    padding 12px
    li
      display inline-block
      vertical-align top
      position relative
      &+li
        margin-left 13px
        &:before
          content ''
          commonBgColor(#40444F, #E9E9E9)
          height 14px
          width 1px
          position absolute
          left -7px
          top 9px
      a
        padding 0 16px
        display inline-block
        vertical-align top
        line-height 32px
        font-size 14px
        commonColor(#E9E9EB, #666666)
        span
          commonColor(#797B83, #AAAAAA)
          margin-left 2px
        &:hover
          color rgba(250, 122, 80, 1)
      &.active
        a, span
          background-color rgba(250, 122, 80, 1)
          color #fff
  .search-type-tip
    margin 0 auto
    display flex
    padding-bottom 10px
    border-bottom 1px solid
    commonBorderColor(#40444F, transparent)
    &-0
      width 970px
    &-1
      width 1020px
    &-2, &-3, &-5, &-4
      width 866px
    &-6
      width 876px
    &-7
      width 870px
    .tip-l
      flex 0 0 200px
      position relative
      span
        font-size 20px
        commonColor(#E9E9EB, #333333)
        display inline-block
        vertical-align top
        font-weight bold
      &:before
        content ''
        display inline-block
        vertical-align top
        background-image url('~pic/search-tip.png')
        background-size 100%
        background-repeat no-repeat
        width 18px
        height 16px
        margin 1px 6px 0 0
    .tip-r
      flex auto
      text-align right
      font-size 12px
      commonColor(#BCBDC1, #666666)
      padding-top 8px
      span
        color rgba(250, 122, 80, 1)
.loading-spin
  position relative
  width 1200px
  margin 0 auto
  height 220px
  .ivu-spin-fix
    background-color transparent
.over
  margin-top 30px
  color #999
  text-align center
.more
  margin-top 30px
  text-align center
  button
    border 1px solid rgba(250, 122, 80, 1)
    background transparent
    border-radius 18px
    width 108px
    height 36px
    color rgba(250, 122, 80, 1)
    font-size 14px
    cursor pointer
    &:hover
      border-color #FC9C7C
      color #FC9C7C
  .more-loading
    width 100%
    height 36px
    position relative
    .ivu-spin-fix
      background-color transparent
.topic
  width 970px
  margin 0 auto
  padding-top 20px
.theme
  width 1020px
  margin 0 auto
  padding-top 20px
.entity
  padding-top 20px
  margin 0 auto
  margin-bottom -10px
  width 866px
.policy
  width 866px
  margin 0 auto
.report
  width 876px
  margin 0 auto
.article
  width 870px
  margin 0 auto
.change-full
  width 1200px
  margin 0 auto
  padding 16px 165px
  commonBgColor(transparent, #FFFFFF)
  span
    font-size 14px
    commonColor(#BCBDC1, #666666)
    cursor pointer
    display inline-block
    vertical-align top
    &:hover
      color rgba(250, 122, 80, 1)
    &.on
      color rgba(250, 122, 80, 1) !important
    &+span
      margin-left 33px
      position relative
      &:before
        content ''
        position absolute
        width 1px
        height 12px
        top 2px
        left -17px
        commonBgColor(#40444F, #F4F6F8)
.search-bottom
  padding-bottom 30px
  commonBgColor(transparent, #FFFFFF)
</style>
